<template>
  <div>
    <v-progress-circular v-if="isUpdating" indeterminate :size="24" />
    <v-checkbox
      v-if="resolvedRole !== 'qc' && !isUpdating"
      :input-value="value"
      @click.native.stop.prevent="handleChange"
    />
  </div>
</template>

<script>
// vuex
import { mapGetters, mapActions } from "vuex";
// internal
import { processAssignment } from "@/utils/newDbUtils";

export default {
  name: "ADAcceptedSelector",
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      required: false,
    },
    // Which field this checkbox writes. The assignments table leaves it unset
    // and lets the component work it out from the assignment's primary and
    // secondary emails; callers that already know the answer — the assignment
    // form, which matches on user id — pass it instead, because a record whose
    // assignees carry no email silently resolves to "qc" and renders nothing.
    // A String, or an Array when one person holds more than one step and a
    // single tick has to accept all of them at once.
    role: {
      type: [String, Array],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    resolvedRoles() {
      if (this.role) return Array.isArray(this.role) ? this.role : [this.role];
      if (this.item.primary?.email === this.user.user.email) {
        return ["primary"];
      } else if (this.item.secondary?.email === this.user.user.email) {
        return ["secondary"];
      } else {
        return ["qc"];
      }
    },
    resolvedRole() {
      return this.resolvedRoles[0];
    },
  },
  methods: {
    ...mapActions("flashMessage", ["handleFlash"]),
    handleChange() {
      this.isUpdating = true;
      const data = {};
      this.resolvedRoles.forEach((role) => {
        data[`${role}Accepted`] = !this.value;
      });
      processAssignment({
        data,
        id: this.item.id,
        patch: true,
      }).then((resp) => {
        if (resp.status <= 204)
          this.$emit(
            "refresh-table-expansion",
            this.item.index,
            !this.value,
            this.resolvedRole,
            resp,
            this.resolvedRoles
          );
        this.isUpdating = false;
        this.handleFlash({ response: resp, show: true });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-progress-circular {
  margin: 0 auto;
}
::v-deep {
  .v-input--checkbox .v-input__control .v-input__slot {
    width: fit-content;
    margin: 0 auto;
    margin-bottom: 8px;
    & .v-input--selection-controls__input {
      margin-right: 0;
    }
  }
}
</style>
